import { render } from "./z-dashboard.svg.js?vue&type=template&id=f556f6e4!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??clonedRuleSet-12.use[0]!../../../../../node_modules/vue-svg-loader-2/index.js??clonedRuleSet-12.use[1]!./z-dashboard.svg?vue&type=template&id=f556f6e4"
const script = {}

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__